import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './Accordion.styles';
import { Placeholder, isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';


const Accordion = ({ fields = {}, params = {}, rendering, sitecoreContext }) => {
  const experienceEditor = isEditorActive();
  const { title } = fields;
  const { isfullwidth } = params;

  return (
    <Container
      isFullWidth={isfullwidth}
      id={'accordion-faq'}
      experienceEditor={experienceEditor || sitecoreContext?.pageEditing}
    >
      {title?.value && <h1>{title.value}</h1>}
      <div className="accordion-wrapper">
        <Placeholder name="accordion-content" rendering={rendering} />
      </div>
    </Container>
  );
};

Accordion.propTypes = {
  fields: PropTypes.object,
  params: PropTypes.object,
  rendering: PropTypes.object,
  isFullWidth: PropTypes.string,
  sitecoreContext: PropTypes.object,
};

export default withSitecoreContext()(Accordion);